import React, { useState , useEffect} from 'react';
import { useParams } from 'react-router';
import Gallery from '../../models/gallery.model';
import { fetchGalleryBySlug } from '../../services/gallery.service';
import { Container , Grid } from '@material-ui/core';
import Breadcrumb from '../../components/Breadcrumb';
import GalleryCard from '../../components/GalleryCard/index';
import Preloader from '../../components/PreLoader';
// import translate from '../../translation.json';
import { lang } from '../../config/app.config';
import {TranslationState} from '../../store/ActionReducers/translation.actionreducer';
import { useSelector } from 'react-redux';

interface params{
  slug:string
}

const GalleryDetails:React.FC = () =>{

  const {slug} = useParams<params>();
  
  const [gallery,setGallery] = useState<Gallery|undefined>(undefined);
  const [loading,setLoading] = useState<boolean>(false);


  const fetchGallery = async() => {
    setLoading(true);
    const gallery = await fetchGalleryBySlug(slug) || undefined;
    setGallery(gallery);
    setLoading(false)
  }

  useEffect(()=>{
    fetchGallery();
  },[slug]) //eslint-disable-line

  const stateTr = useSelector((state:{translation:TranslationState})=>state.translation);


  return(
    <>
    <Breadcrumb slug="gallery" routes={[{title:stateTr.translation?stateTr.translation.gallery[lang==='np'?"value_np":"value_en"]:"",path:'/gallery'},{title:gallery? gallery.name:"Gallery not found"}]}/>
      <div className="text-center curveBackground">
        <h3 className="ecn-title-inv text-26">{gallery? gallery.name:"Gallery not found"}</h3>
      </div>
      {
        loading?<Preloader/>:
          gallery?
        <div className="section-padding-2">
          <Container maxWidth="lg">
            <Grid container spacing={3}>
              {
                gallery && gallery.children.length?
                gallery.children.map((img,i)=>(
                  <Grid item xs={12} sm={2} md={3} lg={4} key={i}>
                    <GalleryCard image={img.value} images={gallery.children} active={i}/>
                  </Grid>
                )): 
                <h3 className="text-center section-break-4 text-28-primary">
                  Gallery has no images!!
                </h3> // no Images
              }
            </Grid>
          </Container>
        </div>:
        <h3 className="text-center section-break-4 text-28-primary">
          Gallery not found!!
        </h3> 
      }
    </>
  );
}

export default GalleryDetails;